import React from 'react'
import { useTranslation } from 'react-i18next'

import { useWindowResize } from '@utils/domUtils'

import { CommonModalTitleProps, ModalProps } from '../types'
import { FilterModalDesktop } from './FilterModalDesktop'
import { FilterModalMobile } from './FilterModalMobile'

export interface FilterModalProps extends ModalProps {
  isLoading?: boolean
  isValid: boolean
  onConfirm(): void
  onClear(): void
}

export const FilterModal: React.FC<CommonModalTitleProps & FilterModalProps> = ({
  title,
  ...restProps
}) => {
  const isMobile = useWindowResize()
  const { t } = useTranslation()

  const props = Object.assign(restProps, { title: title || t('Filters') })

  return isMobile ? <FilterModalMobile {...props} /> : <FilterModalDesktop {...props} />
}
